import { A, useNavigate } from "@solidjs/router";
import { createSignal } from "solid-js";
import { useAuth } from "../auth/AuthContext.tsx";
import { ErrorBanner } from "../components/ErrorBanner.tsx";

export function Register() {
  const { client } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = createSignal("");
  const [password, setPassword] = createSignal("");
  const [error, setError] = createSignal<unknown | null>(null);
  const [busy, setBusy] = createSignal(false);

  async function onSubmit(e: Event) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await client.register({ email: email(), password: password() });
      // The TOTP secret ships back once — hand it to the confirm page via router
      // state so it isn't persisted anywhere on this device.
      navigate("/confirm-totp", {
        replace: true,
        state: {
          accountId: res.accountId,
          totpSecret: res.totpSecret,
          provisioningUri: res.provisioningUri,
        },
      });
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div class="auth-shell">
      <form onSubmit={onSubmit} class="card auth-card">
        <h1>Create your wallet</h1>
        <p class="muted">Pick a strong password — you'll set up 2FA on the next step.</p>
        <ErrorBanner error={error()} />
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          autocomplete="email"
          value={email()}
          onInput={(e) => setEmail(e.currentTarget.value)}
          required
        />
        <label for="password">Password</label>
        <input
          id="password"
          type="password"
          autocomplete="new-password"
          value={password()}
          onInput={(e) => setPassword(e.currentTarget.value)}
          minLength={12}
          required
        />
        <button type="submit" class="primary auth-submit" disabled={busy()}>
          {busy() ? "Creating…" : "Continue"}
        </button>
        <p class="muted auth-alt">
          Already have one? <A href="/login">Sign in</A>
        </p>
      </form>
    </div>
  );
}
